import React, { useEffect, useRef, useState } from "react";
import style from "./VideoPlayer.module.css";

export const VideoPlayer = ({ src, height }) => {
  const videoRef = useRef(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(false);
  }, [src]);

  return (
    <div
      className={style.videoFrame}
      style={{ height }}
      aria-busy={!isLoaded}
    >
      {!isLoaded && <div className={style.skeleton} aria-hidden="true" />}
      <video
        className={`${style.video} ${isLoaded ? style.loaded : ""}`}
        ref={videoRef}
        src={src}
        controls
        preload="metadata"
        onLoadedData={() => setIsLoaded(true)}
        onCanPlay={() => setIsLoaded(true)}
        onError={() => setIsLoaded(true)}
      />
    </div>
  );
};
